import { IEvent } from "../../models/Event";
import { StatusBtn } from "../StatusBtn";
import CountdownTimer from "../countdown/CountdownTimer";

// pinned to the bottom of the screen on mobile and tablet, where the header has no room for the status button
export const MobileCtaBar: React.FC<{ event: IEvent, targetDate: number }> = ({ event, targetDate }) => {
    return (
        <div className="mobile-cta-bar">
            <div className="mobile-cta-bar__info">
                <span className="mobile-cta-bar__date">{event.date}</span>
                <CountdownTimer targetDate={targetDate} compact />
            </div>
            <StatusBtn event={event} />
        </div>
    )
}
